import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Button from "./button/Button";
import CustomCard from "./card/Card";
// import Card from "@mui/material/Card";
const DashboardCardMobile = ({
    title,
    backgroundImageUrl,
    foreGroundImageUrl,
    url,
    HandleOnclick,
    isAlbum = true,
}) => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(true);
    return (
        <div clicked={() => { }} className="whiteripple">
            <div
                className="custom-card rounded-[7px] overflow-hidden relative w-full h-[150px] z-[1] cursor-pointer my-3"
                onClick={isAlbum ? () => navigate(`/${url}`) : HandleOnclick}
            >
                <img
                    // className="disable-context-menu w-full h-full object-cover absolute top-0 left-0 z-[-1]"
                    // src={`https://wedding-patrika.onrender.com/6536d93b5ab5488ebf79aede/${backgroundImageUrl}`}
                    onLoad={() => setIsLoading(false)}
                    className={`disable-context-menu w-full h-full object-cover absolute top-0 left-0 z-[-1] transition-all duration-500 ${isLoading ? "blur-lg scale-105" : "blur-0 scale-100"
                        }`}
                    src={backgroundImageUrl}
                    alt="Background"
                />
                <div className="absolute top-0 left-0 p-[20px] w-full h-full bg-black/40">
                    <div className="border-[2.25px] border-white rounded-[3px] w-full h-full"></div>
                </div>
                <div className="content absolute z-[1] w-full h-full box-border grid place-items-center">
                    {/* padding: 20px; // Set the padding as per your requirement */}
                    {/* {foreGroundImageUrl && ( */}
                    <img
                        className="disable-context-menu foreground-image absolute block w-full h-full object-cover mx-auto"
                        // src={`https://wedding-patrika.onrender.com/6536d93b5ab5488ebf79aede/${foreGroundImageUrl}`}
                        src={foreGroundImageUrl}
                        alt="Foreground"
                        style={{ WebkitFilter: "brightness(70%)" }}
                    />
                    {/* )} */}
                    <p className="text-center text-white font-medium text-[21px] z-[1] pointer-events-none">
                        {title}
                    </p>
                    {/* text-align: center;
                color: white;
                z-index: 1; */}
                </div>
            </div>
        </div>
    );
};

export default DashboardCardMobile;
